import React, { useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

var appendScript = script => {
  if (document.head.querySelector("[src=\"" + script.src + "\"]")) return;
  var scriptElement = document.createElement("script");

  for (var [_key, value] of Object.entries(script)) {
    scriptElement.setAttribute(_key, value);
  }

  document.head.appendChild(scriptElement);
};

export var JobsList = () => {
  useEffect(() => {
    if (window && document) {
      window._jaJobsSettings = {
        key: "AU2_fuwizds3iesufhdj4s6ohfw4om",
        jobListSettings: {
          readMoreText: "Learn More",
          noJobsContent: "There are currently no job opportunities",
          showDatePosted: false
        },
        applicationFormSettings: {
          useExternalApplicationForm: true,
          showExternalApplicationFormInNewWindow: false
        }
      };
      appendScript({
        src: "//jobadder.com/widgets/v1/jobs.min.js"
      });
    }
  }, []);
  return /*#__PURE__*/_jsx("div", {
    id: "ja-jobs-widget",
    className: "jobs_list"
  });
};
//# sourceMappingURL=jobs_list.js.map